import { Link } from 'react-router-dom';

import Styles from './index.module.scss';

export const ButtonLink = (props: React.ComponentPropsWithRef<typeof Link>) => {
	return <Link {...props} className={Styles.container} />;
};
